import { IEmployeeInfo } from './_types';

export const EMPLOYEES_INFO: IEmployeeInfo[] = [
  {
    imageUrl: '/assets/images/company-employees/0ddb7866-a6a0-4877-9fd2-ee9a7e0fb466.jpeg',
  },
  {
    imageUrl: '/assets/images/company-employees/33db9496-9a79-4f34-9f80-e6ea9588984f.jpeg',
  },
  {
    imageUrl: '/assets/images/company-employees/60d2c205-b802-42a9-b861-68950c0ff2af.jpeg',
  },
  {
    imageUrl: '/assets/images/company-employees/82f31872-28a3-4746-8980-2c6166a31123.jpeg',
  },
  {
    imageUrl: '/assets/images/company-employees/3037be88-53ea-42f0-9205-b3b39bc21b5f.jpeg',
  },
  {
    imageUrl: '/assets/images/company-employees/b4f645f5-53b3-4035-80a3-834aa03327cc.jpeg',
  },
  {
    imageUrl: '/assets/images/company-employees/bd81bf86-0c8d-49e4-8a86-6685c1a09a66.jpeg',
  },
  {
    imageUrl: '/assets/images/company-employees/fc4a3dd9-cd8f-4572-801b-3dca69798279.jpeg',
  },
];

export const LOGIN_ERRORS_MAP: Record<string, string> = {
  email: 'ROOT.LOGIN_PAGE.ERROR_EMAIL_INVALID',
  required: 'ROOT.LOGIN_PAGE.ERROR_EMAIL_INVALID',
  invalidAttempt: 'ROOT.LOGIN_PAGE.ERROR_INVALID_ATTEMPT',
};
